import React from "react";

import FeedBackModal from "../../../../components/Reviews/FeedBackModal/FeedBackModal";
import { sections } from "../../../../handlers/enums";
import { convertDateToWords, convertUlToArray, removeHTTPAndDomainName } from "../../../../handlers/utilityFunctions";
import useReviewFeedBack from "../../../../hooks/use-ReviewFeedBack";

function ResumePremiumNine(props) {
	const { isReview, reviewData, resumeData, hasFeedback, activeSection, onSubmitFeedBack, loadingSubmission } = props;
	const { useReviewFeedback, feedBackButton } = useReviewFeedBack(reviewData);

	return (
		<div className="resume-scope final-resume-preview-wrapper final-premium-template-9 final-premium-template-5 final-resume-preview-new shadow-sm">
			<div className=" text-[#343a40] py-4">
				<div className="max-w-[1140px] mx-auto px-[15px] ">
					{resumeData.contactInfo.firstName !== "" && (
						<div className="flex mb-4 lg:mb-6">
							<div
								className="border-block"
								style={{
									backgroundColor: "#183042",
									height: "70px",
									flex: "0 0 50px",
									marginRight: "15px",
									marginTop: "10px",
								}}
							>
								&nbsp;
							</div>
							<div style={{ flexGrow: 1 }}>
								<div className="flex flex-wrap">
									<div className="w-2/3 pr-4">
										<h3 className="mb-0 capitalize">
											{resumeData.contactInfo.firstName} {resumeData.contactInfo.lastName}
										</h3>
										<h4 className="mb-2" style={{ color: "#458b67", fontWeight: 500 }}>
											{resumeData.contactInfo.resumeTitle}
										</h4>
										<div
											className={`relative review-section ${
												isReview
													? "rs-highlight"
													: hasFeedback
														? activeSection === sections.SUMMARY
															? "rs-feedback rs-feedback-active"
															: "rs-feedback"
														: ""
											}`}
											id={sections.SUMMARY}
											style={{
												backgroundColor:
													useReviewFeedback.section.section === sections.SUMMARY ? "rgba(27, 175, 245, 0.12)" : "",
											}}
										>
											{isReview || activeSection === sections.SUMMARY
												? feedBackButton(sections.SUMMARY, hasFeedback)
												: null}
											<p
												className="mb-2"
												dangerouslySetInnerHTML={{
													__html: resumeData.summary,
												}}
											/>
										</div>
									</div>
									<div className="w-1/3">
										<div>
											<p className="mb-1 md:mb-2 text-right">
												{resumeData.contactInfo.email}
												<i
													className="ml-2 fa fa-envelope contact-icon"
													style={{ color: "#183042" }}
													aria-hidden="true"
												/>
											</p>
											<p className="mb-1 md:mb-2 text-right">
												{resumeData.contactInfo.phoneNo}{" "}
												<i className="ml-2 fa fa-mobile contact-icon" style={{ color: "#183042" }} aria-hidden="true" />
											</p>
											<p className="mb-1 md:mb-2 text-right">
												{resumeData.contactInfo.city}, {resumeData.contactInfo.country}
												<i
													className="ml-2 fa fa-map-marker contact-icon"
													style={{ color: "#183042" }}
													aria-hidden="true"
												/>
											</p>
											{[...resumeData.extras.personalLinks].map((link, index) => {
												return link.type !== "otherLink" ? (
													<p key={index} className="mb-1 md:mb-2 text-right">
														<a href={link.value} target="_blank" rel="noreferrer" className="text-[#343a40]">
															{removeHTTPAndDomainName(link)}
														</a>
														<i
															className={`ml-2 contact-icon ${
																link.type === "linkedIn"
																	? "bi bi-linkedin"
																	: link.type === "twitter"
																		? "bi bi-twitter"
																		: link.type === "github"
																			? "bi bi-github"
																			: "fa fa-link"
															}`}
															style={{ color: "#183042" }}
															aria-hidden="true"
														/>
													</p>
												) : null;
											})}
										</div>
									</div>
								</div>
							</div>
						</div>
					)}

					<hr className="mb-4 md:mb-6 border-line w-full" style={{ borderTop: "2px solid #458b67" }} />

					{resumeData.skills !== "" && convertUlToArray(resumeData.skills) ? (
						<div className="flex mb-4 lg:mb-6">
							<div
								className="border-block"
								style={{ height: "70px", flex: "0 0 50px", marginRight: "15px", marginTop: "10px" }}
							>
								&nbsp;
							</div>
							<div style={{ flexGrow: 1 }}>
								<h3 className="uppercase">skills</h3>
								<ul
									className={`p-0 mb-0 relative review-section ${
										isReview
											? "rs-highlight"
											: hasFeedback
												? activeSection === sections.SKILLS
													? "rs-feedback rs-feedback-active"
													: "rs-feedback"
												: ""
									}`}
									id={sections.SKILLS}
									style={{
										listStyle: "none",
										backgroundColor:
											useReviewFeedback.section.section === sections.SKILLS ? "rgba(27, 175, 245, 0.12)" : "",
									}}
								>
									{isReview || activeSection === sections.SKILLS ? feedBackButton(sections.SKILLS, hasFeedback) : null}
									{convertUlToArray(resumeData.skills).map((item, index) => {
										const splitArray = item.value.split(/:(.+)/);
										let wordBeforeColon = splitArray[0].trim();
										wordBeforeColon = splitArray.length > 1 ? <strong>{wordBeforeColon}</strong> : wordBeforeColon;
										const wordAfterColon = splitArray.length > 1 ? ": " + splitArray[1].trim() : "";

										return (
											<li key={index} className="flex items-center mb-2">
												{wordBeforeColon}
												{wordAfterColon}
											</li>
										);
									})}
								</ul>
							</div>
						</div>
					) : null}

					{resumeData.extras.certifications !== "" ? (
						<div className="flex mb-4 lg:mb-6">
							<div
								className="border-block"
								style={{ height: "70px", flex: "0 0 50px", marginRight: "15px", marginTop: "10px" }}
							>
								&nbsp;
							</div>
							<div style={{ flexGrow: 1 }}>
								<h3 className="uppercase">CERTIFICATES</h3>
								<div
									className={`flex flex-wrap relative review-section ${
										isReview
											? "rs-highlight"
											: hasFeedback
												? activeSection === sections.CERTIFICATION
													? "rs-feedback rs-feedback-active"
													: "rs-feedback"
												: ""
									}`}
									id={sections.CERTIFICATION}
									style={{
										backgroundColor:
											useReviewFeedback.section.section === sections.CERTIFICATION ? "rgba(27, 175, 245, 0.12)" : "",
									}}
								>
									{isReview || activeSection === sections.CERTIFICATION
										? feedBackButton(sections.CERTIFICATION, hasFeedback)
										: null}
									{convertUlToArray(resumeData.extras.certifications).map((item, index) => {
										return (
											<div key={index} className="w-1/2 mb-2 pr-2">
												<p className="flex items-center">
													<span>{item.value}</span>
												</p>
											</div>
										);
									})}
								</div>
							</div>
						</div>
					) : null}

					{resumeData.extras.accomplishments !== "" ? (
						<div className="flex mb-4 lg:mb-6">
							<div
								className="border-block"
								style={{ height: "70px", flex: "0 0 50px", marginRight: "15px", marginTop: "10px" }}
							>
								&nbsp;
							</div>
							<div style={{ flexGrow: 1 }}>
								<h3 className="uppercase">accomplishments</h3>
								<ul
									className={`p-0 mb-0 relative review-section ${
										isReview
											? "rs-highlight"
											: hasFeedback
												? activeSection === sections.ACCOMPLISHMENTS
													? "rs-feedback rs-feedback-active"
													: "rs-feedback"
												: ""
									}`}
									id={sections.ACCOMPLISHMENTS}
									style={{
										listStyle: "none",
										backgroundColor:
											useReviewFeedback.section.section === sections.ACCOMPLISHMENTS ? "rgba(27, 175, 245, 0.12)" : "",
									}}
								>
									{isReview || activeSection === sections.ACCOMPLISHMENTS
										? feedBackButton(sections.ACCOMPLISHMENTS, hasFeedback)
										: null}
									{convertUlToArray(resumeData.extras.accomplishments).map((item, index) => {
										return (
											<li key={index} className="flex items-center mb-2">
												{item.value}
											</li>
										);
									})}
								</ul>
							</div>
						</div>
					) : null}

					{resumeData.workHistory.length > 0 && resumeData.workHistory[0].jobTitle !== "" ? (
						<div className=" mb-4 lg:mb-6">
							<div className="flex">
								<div
									className="border-block-space"
									style={{ flex: "0 0 50px", marginRight: "15px", marginTop: "10px" }}
								>
									&nbsp;
								</div>
								<div style={{ flexGrow: 1 }}>
									<h3 className="uppercase">WORK EXPERIENCE</h3>
								</div>
							</div>
							<div className="flex">
								<div
									className="border-block"
									style={{
										backgroundColor: "#458b67",
										height: "70px",
										flex: "0 0 50px",
										marginRight: "15px",
										marginTop: "10px",
									}}
								>
									&nbsp;
								</div>
								<div
									className={`relative review-section ${
										isReview
											? "rs-highlight"
											: hasFeedback
												? activeSection === sections.EXPERIENCE
													? "rs-feedback rs-feedback-active"
													: "rs-feedback"
												: ""
									}`}
									id={sections.EXPERIENCE}
									style={{
										flexGrow: 1,
										backgroundColor:
											useReviewFeedback.section.section === sections.EXPERIENCE ? "rgba(27, 175, 245, 0.12)" : "",
									}}
								>
									{isReview || activeSection === sections.EXPERIENCE
										? feedBackButton(sections.EXPERIENCE, hasFeedback)
										: null}
									{[...resumeData.workHistory].map((job, index) => (
										<React.Fragment key={index}>
											<div className="mb-4 md:mb-6">
												<div className="flex justify-between">
													<p className="mb-2">
														<strong>{job.employer}</strong>
														{" - "}
														{job.city}, {job.country}
														<br />
														<em>{job.jobTitle}</em>
													</p>
													<p className="mb-0" style={{ color: "#458b67" }}>
														<strong>
															{convertDateToWords(job.startDate)} -{" "}
															{job.endDate !== "" ? convertDateToWords(job.endDate) : "Present"}
														</strong>
													</p>
												</div>
												<div className="flex items-center justify-between italic" style={{ color: "#458b67" }}>
													<p className="mb-2">Achievements</p>
												</div>
												<ul className="p-0 mb-0" style={{ listStyle: "none" }}>
													{convertUlToArray(job.details).map((item, index) => {
														return (
															<li key={index} className="flex items-center">
																<span
																	style={{
																		fontWeight: 500,
																		flex: "0 0 20px",
																		fontSize: "5px",
																		color: "#458b67",
																	}}
																>
																	<span className="fa fa-circle" />
																</span>
																<span className="w-full">{item.value}</span>
															</li>
														);
													})}
												</ul>
											</div>
										</React.Fragment>
									))}
								</div>
							</div>
						</div>
					) : null}

					{resumeData.education.length > 0 && (
						<div className=" mb-4 lg:mb-6">
							<div className="flex">
								<div
									className="border-block-space"
									style={{ flex: "0 0 50px", marginRight: "15px", marginTop: "10px" }}
								>
									&nbsp;
								</div>
								<div style={{ flexGrow: 1 }}>
									<h3 className="uppercase">EDUCATION</h3>
								</div>
							</div>
							<div className="flex">
								<div
									className="border-block"
									style={{
										backgroundColor: "#458b67",
										height: "70px",
										flex: "0 0 50px",
										marginRight: "15px",
										marginTop: "10px",
									}}
								>
									&nbsp;
								</div>
								<div
									className={`relative review-section ${
										isReview
											? "rs-highlight"
											: hasFeedback
												? activeSection === sections.EDUCATION
													? "rs-feedback rs-feedback-active"
													: "rs-feedback"
												: ""
									}`}
									id={sections.EDUCATION}
									style={{
										flexGrow: 1,
										backgroundColor:
											useReviewFeedback.section.section === sections.EDUCATION ? "rgba(27, 175, 245, 0.12)" : "",
									}}
								>
									{isReview || activeSection === sections.EDUCATION
										? feedBackButton(sections.EDUCATION, hasFeedback)
										: null}
									{[...resumeData.education].map((educationHistory, index) => (
										<div key={index} className="mb-4">
											<div className="flex justify-between">
												<p>
													<strong>{educationHistory.schoolName}</strong>
													{" - "}
													{educationHistory.schoolCity}, <br />
													<em>{educationHistory.fieldOfStudy}</em>
												</p>
												<p className="mr-6" style={{ color: "#458b67" }}>
													<strong>{educationHistory.gYear}</strong>
												</p>
											</div>
											<ul className="p-0 mb-0" style={{ listStyle: "none" }}>
												{convertUlToArray(educationHistory.description).map((item, index) => {
													if (item.value === "") {
														return null;
													}
													return (
														<li key={index} className="flex items-center">
															<span
																style={{
																	fontWeight: 500,
																	flex: "0 0 20px",
																	fontSize: "5px",
																	color: "#458b67",
																}}
															>
																<span className="fa fa-circle" />
															</span>
															<span className="w-full">{item.value}</span>
														</li>
													);
												})}
											</ul>
										</div>
									))}
								</div>
							</div>
						</div>
					)}

					{resumeData.extras.languages.length !== 0 ? (
						<div className="flex mb-4 lg:mb-6">
							<div
								className="border-block"
								style={{ height: "70px", flex: "0 0 50px", marginRight: "15px", marginTop: "10px" }}
							>
								&nbsp;
							</div>
							<div style={{ flexGrow: 1 }}>
								<h3 className="uppercase">LANGUAGES</h3>
								<div
									className={`flex flex-wrap relative review-section ${
										isReview
											? "rs-highlight"
											: hasFeedback
												? activeSection === sections.LANGUAGES
													? "rs-feedback rs-feedback-active"
													: "rs-feedback"
												: ""
									}`}
									id={sections.LANGUAGES}
									style={{
										backgroundColor:
											useReviewFeedback.section.section === sections.LANGUAGES ? "rgba(27, 175, 245, 0.12)" : "",
									}}
								>
									{isReview || activeSection === sections.LANGUAGES
										? feedBackButton(sections.LANGUAGES, hasFeedback)
										: null}
									{resumeData.extras.languages.map((language, index) => (
										<div key={index} className="w-1/2">
											<h6 className="mt-2 mb-2 font-bold">
												{language.language}
												<p className="italic mb-0" style={{ color: "#777777", fontWeight: 500 }}>
													{language.proficiency}
												</p>
											</h6>
										</div>
									))}
								</div>
							</div>
						</div>
					) : null}

					{resumeData.extras.personalProfile.dateOfBirth && (
						<div className="flex mb-4 lg:mb-6">
							<div
								className="border-block"
								style={{ height: "70px", flex: "0 0 50px", marginRight: "15px", marginTop: "10px" }}
							>
								&nbsp;
							</div>
							<div style={{ flexGrow: 1 }}>
								<h3 className="uppercase">Personal Information</h3>
								<div
									className={`flex flex-wrap relative review-section ${
										isReview
											? "rs-highlight"
											: hasFeedback
												? activeSection === sections.PERSONAL
													? "rs-feedback rs-feedback-active"
													: "rs-feedback"
												: ""
									}`}
									id={sections.PERSONAL}
									style={{
										backgroundColor:
											useReviewFeedback.section.section === sections.PERSONAL ? "rgba(27, 175, 245, 0.12)" : "",
									}}
								>
									{isReview || activeSection === sections.PERSONAL
										? feedBackButton(sections.PERSONAL, hasFeedback)
										: null}
									<div className="w-1/2">
										<div className="mb-2 md:mb-4">
											<strong>Date of Birth:</strong>&nbsp;
											{resumeData.extras.personalProfile.dateOfBirth}
										</div>
									</div>
									<div className="w-1/2">
										<div className="mb-2 md:mb-4">
											<strong>Gender:</strong>&nbsp;
											{resumeData.extras.personalProfile.gender}
										</div>
									</div>
									<div className="w-1/2">
										<div className="mb-2 md:mb-4">
											<strong>Marital Status:</strong>&nbsp;
											{resumeData.extras.personalProfile.maritalStatus}
										</div>
									</div>
								</div>
							</div>
						</div>
					)}

					{resumeData.extras.affiliations !== "" ? (
						<div className="flex mb-4 lg:mb-6">
							<div
								className="border-block"
								style={{ height: "70px", flex: "0 0 50px", marginRight: "15px", marginTop: "10px" }}
							>
								&nbsp;
							</div>
							<div style={{ flexGrow: 1 }}>
								<h3 className="uppercase">affiliations</h3>
								<div
									className={`flex flex-wrap relative review-section ${
										isReview
											? "rs-highlight"
											: hasFeedback
												? activeSection === sections.AFFILIATION
													? "rs-feedback rs-feedback-active"
													: "rs-feedback"
												: ""
									}`}
									id={sections.AFFILIATION}
									style={{
										backgroundColor:
											useReviewFeedback.section.section === sections.AFFILIATION ? "rgba(27, 175, 245, 0.12)" : "",
									}}
								>
									{isReview || activeSection === sections.AFFILIATION
										? feedBackButton(sections.AFFILIATION, hasFeedback)
										: null}
									{convertUlToArray(resumeData.extras.affiliations).map((item, index) => {
										return (
											<div key={index} className="w-1/2 mb-2 pr-2">
												<p className="flex items-center">
													<span>{item.value}</span>
												</p>
											</div>
										);
									})}
								</div>
							</div>
						</div>
					) : null}

					{resumeData.extras.additionalInfo !== "" ? (
						<div className="flex mb-4 lg:mb-6">
							<div
								className="border-block"
								style={{ height: "70px", flex: "0 0 50px", marginRight: "15px", marginTop: "10px" }}
							>
								&nbsp;
							</div>
							<div style={{ flexGrow: 1 }}>
								<h3 className="uppercase">additional information</h3>
								<div
									className={`flex flex-wrap relative review-section ${
										isReview
											? "rs-highlight"
											: hasFeedback
												? activeSection === sections.ADDITIONAL_INFO
													? "rs-feedback rs-feedback-active"
													: "rs-feedback"
												: ""
									}`}
									id={sections.ADDITIONAL_INFO}
									style={{
										backgroundColor:
											useReviewFeedback.section.section === sections.ADDITIONAL_INFO ? "rgba(27, 175, 245, 0.12)" : "",
									}}
								>
									{isReview || activeSection === sections.ADDITIONAL_INFO
										? feedBackButton(sections.ADDITIONAL_INFO, hasFeedback)
										: null}
									{convertUlToArray(resumeData.extras.additionalInfo).map((item, index) => {
										return (
											<div key={index} className="w-1/2 mb-2 pr-2">
												<p className="flex items-center">
													<span>{item.value}</span>
												</p>
											</div>
										);
									})}
								</div>
							</div>
						</div>
					) : null}

					{[...resumeData.extras.personalLinks].some((link) => link.type === "otherLink") && (
						<div className="flex mb-4 lg:mb-6">
							<div
								className="border-block"
								style={{ height: "70px", flex: "0 0 50px", marginRight: "15px", marginTop: "10px" }}
							>
								&nbsp;
							</div>
							<div style={{ flexGrow: 1 }}>
								<h3 className="uppercase">website, portfolio, profiles</h3>
								<ul
									className={`p-0 mb-0 relative review-section ${
										isReview
											? "rs-highlight"
											: hasFeedback
												? activeSection === sections.LINKS
													? "rs-feedback rs-feedback-active"
													: "rs-feedback"
												: ""
									}`}
									id={sections.LINKS}
									style={{
										listStyle: "none",
										backgroundColor:
											useReviewFeedback.section.section === sections.LINKS ? "rgba(27, 175, 245, 0.12)" : "",
									}}
								>
									{isReview || activeSection === sections.LINKS ? feedBackButton(sections.LINKS, hasFeedback) : null}
									{[...resumeData.extras.personalLinks].map((link, index) => {
										return link.type === "otherLink" ? (
											<li key={index} className="flex items-center mb-2">
												{link.value}
											</li>
										) : null;
									})}
								</ul>
							</div>
						</div>
					)}

					{resumeData.extras.references.length > 0 ? (
						<div className="flex mb-4 lg:mb-6">
							<div
								className="border-block"
								style={{ height: "70px", flex: "0 0 50px", marginRight: "15px", marginTop: "10px" }}
							>
								&nbsp;
							</div>
							<div style={{ flexGrow: 1 }}>
								<h3 className="uppercase">references</h3>
								<div
									className={`flex flex-wrap relative review-section ${
										isReview
											? "rs-highlight"
											: hasFeedback
												? activeSection === sections.REFERENCE
													? "rs-feedback rs-feedback-active"
													: "rs-feedback"
												: ""
									}`}
									id={sections.REFERENCE}
									style={{
										backgroundColor:
											useReviewFeedback.section.section === sections.REFERENCE ? "rgba(27, 175, 245, 0.12)" : "",
									}}
								>
									{isReview || activeSection === sections.REFERENCE
										? feedBackButton(sections.REFERENCE, hasFeedback)
										: null}
									{[...resumeData.extras.references].map((reference, index) => (
										<div key={index} className="w-1/2 flex mb-4">
											<div>
												<strong>{reference.name}</strong>
												{" - "}
												<em>{reference.designation}, </em>
												{reference.workPlace}
												<br />
												<p style={{ color: "#bcbcbc" }}>
													{reference.email}, {reference.phoneNumber}
												</p>
											</div>
										</div>
									))}
								</div>
							</div>
						</div>
					) : null}

					{resumeData.extras.customExtras.name.length > 0 ? (
						<div className="flex mb-4 lg:mb-6">
							<div
								className="border-block"
								style={{ height: "70px", flex: "0 0 50px", marginRight: "15px", marginTop: "10px" }}
							>
								&nbsp;
							</div>
							<div style={{ flexGrow: 1 }}>
								<h3 className="uppercase">{resumeData.extras.customExtras.name}</h3>
								<div
									className={`flex flex-wrap relative review-section ${
										isReview
											? "rs-highlight"
											: hasFeedback
												? activeSection === sections.CUSTOM
													? "rs-feedback rs-feedback-active"
													: "rs-feedback"
												: ""
									}`}
									id={sections.CUSTOM}
									style={{
										backgroundColor:
											useReviewFeedback.section.section === sections.CUSTOM ? "rgba(27, 175, 245, 0.12)" : "",
									}}
								>
									{isReview || activeSection === sections.CUSTOM ? feedBackButton(sections.CUSTOM, hasFeedback) : null}
									{convertUlToArray(resumeData.extras.customExtras.data).map((item, index) => {
										return (
											<div key={index} className="w-1/2 mb-2 pr-2">
												<p className="flex items-center">
													<span>{item.value}</span>
												</p>
											</div>
										);
									})}
								</div>
							</div>
						</div>
					) : null}
				</div>
			</div>
			{useReviewFeedback.showFeedBackModal && (
				<FeedBackModal
					resumeData={resumeData}
					details={useReviewFeedback.section}
					onSubmitFeedBack={onSubmitFeedBack}
					loadingSubmission={loadingSubmission}
				/>
			)}
		</div>
	);
}

export default ResumePremiumNine;
